// 配额模块
export default {
    Quota: {
        Quota: '配额',
        AddQuotaOptions: '新增配额选项',
        Name: '名称',
        deleteIt: '确定删除吗？',
        RuleType: '规则类型',
        DisplayQuota: '显示配额',
        HideQuota: '隐藏配额',
        QuotaNumber: '配额数',
        CompleteNumber: '完成数',
        RuleName: '规则名称',
        DisplayQuotaTip: '（在作答过程中校验配额，配额已满即不可选择）',
        QuotaFullTip: '配额已满提示文案',
        QuotaFullPlaceholder: '配额已满（最多十个字）',
        HideQuotaTip: '（在提交答卷后校验配额，配额已满自动标记为无效答卷）',
        RuleCondition1: '规则条件1',
        PleaseSelect: '请选择',
        AddConditions: '添加条件',
        RuleCondition2: '规则条件2',
        QuotaDetails: '配额详情',
        NotSetTotalQuota: '（可留空，留空默认为不设置配额总数）',
        FillDown: '向下填充',
        QuotaQuantity: '配额数量',
        ModifyQuotaCount: '修改配额数',
        PleaseEnterModifyQuotaCount: '请输入修改配额数值',
        AddQuotaRules: '新增配额规则',
        ModifyQuotaRules: '修改配额规则',
        PleaseEnterNumberQuotasModify: '请输入要修改的配额数',
        SuccessfullyDeleted: '删除成功'
    },
  };